import { useMutation, useQueryClient } from '@tanstack/react-query';

import topicKeys from 'hooks/topic-management/_queryKeys';

// models
import { FormulaUpdateBase } from '../../models/formula.model';

// service
import API from '../../services/api';

import alternateKeys from '../alternates/_queryKeys';
import formulaSequencesKeys from '../formula-sequence/__queryKeys';
// helper
import formulaKeys from './_queryKeys';

const useFormulaUpdateBaseMutation = (
    formulaId: number,
    sequenceId?: string,
    isInvalidateMessageContent?: boolean,
) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (updates: FormulaUpdateBase) => API.updateFormula(updates),

        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: formulaKeys.all });
            queryClient.invalidateQueries({
                queryKey: ['personalization-map'],
            });
            queryClient.invalidateQueries({
                queryKey: formulaKeys.formulaFetchAll(),
            });
            queryClient.invalidateQueries({
                queryKey: [
                    ...formulaKeys.formulaLabelAlternateCount(formulaId),
                ],
            });
            queryClient.invalidateQueries({
                queryKey: [...alternateKeys.getAllVariants()],
            });
            queryClient.invalidateQueries({ queryKey: topicKeys.all() });

            if (isInvalidateMessageContent) {
                queryClient.invalidateQueries({
                    queryKey: formulaKeys.formulaMessageContents(formulaId),
                });
                queryClient.invalidateQueries({
                    queryKey: ['message-content'],
                });
            }

            if (sequenceId) {
                queryClient.invalidateQueries({
                    queryKey: formulaSequencesKeys.detail(sequenceId),
                });
            }
        },

        onMutate: (updates) => {
            const queryKey = formulaKeys.formulaById(
                !formulaId ? updates.id : formulaId,
            );
            const previousFormula = queryClient.getQueryData(queryKey);
            queryClient.setQueryData(queryKey, (storedFormula: any) => {
                return {
                    ...storedFormula,
                    ...updates,
                };
            });
            return { previousFormula };
        },

        onError: (err, newFormula, context) => {
            const queryKey = formulaKeys.formulaById(formulaId);
            queryClient.setQueryData(queryKey, context?.previousFormula);
        },
    });
};

export default useFormulaUpdateBaseMutation;
